import React, { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Each from '../../components/Each';
import styles from '../DashBoard/ExternalDash/ApplicationUIPrimarySidebar.module.css'
const Sidebar = ({activeTab, setActiveTab}) => {
    const navigate=useNavigate();
    const location=useLocation();


    const pathname=location.pathname
    const startLinks={
        'Getting Started':[
            {
                name:"Docs",
                tab:"DOCS"
            },
            {
                name:"EU-Data Subject Rights Process",
                tab:"EU-Rights"
            },
            {
                name:"FAQ",
                tab:"FAQTAB"
            },
            {
                name:"Registration Kit",
                tab:"Registration-Kit"
            },
            {
                name:"Contact Us",
                tab:"ContactUS"
            }
            // {
            //     name:"Create a document design",
            //     link:"/dashboard/Help/CreateDocument"
            // },
            // {
            //     name:"Edit a template",
            //     link:"/dashboard/Help/EditTemplate"
            // }
        ],
        'Tasks':[
            {
                name:"Manage issued documents",
                link:"/dashboard/Help/Manage_issued_documents"
            },
            {
                name:"Manage Change Request",
                link:"/dashboard/Help/Manage_Change_Request"
            },
            {
                name:"Edit Profile",
                link:"/dashboard/Help/Edit_Profile"
            }
        ]
    }
  return (
    <div className={styles.Help}>
        <div className={styles.Header}>Getting Started</div>
        <Each of={startLinks["Getting Started"]} render={(item, index) => {
            return <div className={`${styles.overview} ${activeTab === item.tab ? styles.LinkActive:""}`} onClick={()=>setActiveTab(item.tab)}>
            <Link to={item.link} className={`${styles.linkLabel} ${activeTab === item.tab ? styles.active : ''}`} style={{whiteSpace:"nowrap"}}>
            <div className={styles.HelpLinks}>
                {item.name}
            </div>
            </Link>
            </div>}}
            />
        {/* <div className={styles.Header}>Tasks</div>
        <Each of={startLinks["Tasks"]} render={(item, index) => {
            return <div className={`${styles.overview} ${pathname === item.link?styles.LinkActive:""} `} key={index}>
            <Link to={item.link} className={`${styles.linkLabel} ${pathname === item.link ? styles.active : ''}`}>
            <div className={styles.HelpLinks}>
                {item.name}
            </div>
            </Link>
            </div>}}
            /> */}

      
    </div>
  )
};

export default Sidebar;
